import { Modal, Button } from "react-bootstrap";

export default function CustomModal({
  children,
  show,
  setShowModal,
  setShowPreviewModal,
  handleSubmit,
  motives,
  msg,
  title = "",
  button,
}) {
  const handleClose = () => setShowModal(false);

  return (
    <Modal
      show={show}
      onHide={() => setShowModal(false)}
      aria-label={`Modal with message: ${msg}`}
      className={"inter"}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ whiteSpace: "pre-wrap" }}>{msg}</p>
        <ul className={"text-muted"}>
          {motives && motives.map((motive, i) => <li key={i}>{motive}</li>)}
        </ul>
        {children}
        <div className="text-center">
          <Button
            className="mt-2 px-3 py-2 inter"
            variant="outline-primary"
            size="sm"
            onClick={() => setShowPreviewModal(true)}
          >
            Preview questions
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer className={"flex justify-between"}>
        <Button
          className="px-3 py-2 inter text-white"
          variant="primary"
          onClick={handleClose}
        >
          Continue Assessment
        </Button>
        <Button
          className="px-3 py-2 inter text-white"
          variant="dark"
          color="inherit"
          onClick={handleSubmit}
        >
          {button}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
